import Components from './../Component';

export default class FormAjax extends Components {
  constructor($) {
    super($);
  }

  init(index, element) {
    /*
    var s = 0;
    setInterval(function(){
        s++;
    },1000);
    */

    this.loadingText = this.$(element).attr('data-loading-text');
    let t = this;

    const files = document.getElementById("files");
    if (files){
        files.addEventListener("input", (event) => {

          const maxSize = 35 * 1024 * 1024; // 35MB en octets
          let fileSizeError = false;
          for (let i = 0; i < event.currentTarget.files.length; i++) {
              if (event.currentTarget.files[i].size > maxSize) {
                fileSizeError = true;
              }
          }

          if (fileSizeError){
            const errorFileSizeText = document.getElementById('file-size-error').innerText;
            files.setCustomValidity(errorFileSizeText);
          }

          let fileCountError = false;

          console.log(event.currentTarget.files.length);
          if (event.currentTarget.files.length > 3){
            fileCountError = true;
          }

          if (fileCountError){
            const errorFileCountText = document.getElementById('file-count-error').innerText;
            files.setCustomValidity(errorFileCountText);
          }

          if (!fileCountError && !fileSizeError){
            files.setCustomValidity("");
          }

        });
    }

    /*
    document.getElementById('files').addEventListener('change', function() {

      this.setCustomValidity("I am expecting an email address!");

      const maxSize = 35 * 1024 * 1024; // 35MB en octets
      let fileSizeError = false;
      for (let i = 0; i < this.files.length; i++) {
          if (this.files[i].size > maxSize) {
            fileSizeError = true;
          }
      }

      let fileCountError = false;
      if (this.files.length > 3){
        fileCountError = true;
      }

      const errorFileSizeContainer = document.getElementById('file-size-error');
      if (fileSizeError) {
          //Remove class hidden
          errorFileSizeContainer.classList.remove('hidden');
      } else {
        errorFileSizeContainer.classList.add('hidden');
      }

      const errorFileCountContainer = document.getElementById('file-count-error');
      if (fileCountError) {
          //Remove class hidden
          errorFileCountContainer.classList.remove('hidden');
      } else {
        errorFileCountContainer.classList.add('hidden');
      }

      t.$(element).find('.form-actions input[type="submit"]').attr('disabled','disabled');



  });
  */


    this.$(element).submit(function (event) {

      var self = this;

      console.log(event.currentTarget); // Débogage pour vérifier l'élément

      var formData = new FormData(event.currentTarget);
      //var data = this.$(element).serializeArray();

      self.$(element).find('input, select, textarea').attr('disabled', 1);

      self.$(element).find('.form-message').html(this.loadingText);
      self.$(element).find('.form-message').show();

      self.$.ajax({
        url: self.$(element).attr('data-action'), // ou une URL spécifique
        type: 'POST',
        data: formData,
        processData: false, // Empêcher jQuery de transformer les données en chaîne de requête
        contentType: false, // Empêcher jQuery d'ajuster le type de contenu
        success: function(data) {
          self.$(element).find('.form-message').html(data.response);
          self.$(element).find('.form-message').show();

          if(data.error) {
            self.$(element).find('.form-message').css({'color': 'red'});
          }

          self.$(element).find('input, select, textarea').removeAttr('disabled');

          //Check if _paq is defined
          if(typeof _paq !== 'undefined') {
            _paq.push(['trackEvent', 'Form', 'Send', self.$(element).attr('data-form-label')]);
          }

          var action = self.$(element).attr('data-action') || '';
          if (action.indexOf('unsubscribe') !== -1){
            //get reason from checkbox "reason"
            const reason = self.$(element).find('input[name="reason"]:checked').val() || 'none';
            _paq.push(['trackEvent', 'micro', 'submit', 'newsletter unsubscribe : ' + reason]);
          }
          if (action.indexOf('subscribe') !== -1 && action.indexOf('unsubscribe') === -1){
            _paq.push(['trackEvent', 'macro', 'submit', 'newsletter']);
          }
          if (action.indexOf('contact') !== -1){
            //get label of selected option
            const serviceLabel = self.$(element).find('select[name="service"] option:selected').text() || 'general';
            _paq.push(['trackEvent', 'macro', 'submit', 'contact form : ' + serviceLabel]);
          }




        },
        error: function(xhr, status, error) {
          console.error(error);
          // Gérer l'erreur ici
        }
      });


      /*


      if (s > 4){

          if (this.$(element).find('textarea[name=comment]').val() == ''){
              //post with js

              var data = this.$(element).serializeArray();

              this.$(element).find('input, select, textarea').attr('disabled',1);

              data.push({name: 's', value: s*1.45668251});
              s = 0;

              this.$.post( this.$(element).attr('data-action'), data)
                  .done(function( data ) {

                      this.$(element).find('.form-message').html(data.response);
                      this.$(element).find('.form-message').show();
                  }.bind(this));
          }

      }
      */

      event.preventDefault();
      return false;

    }.bind(this));
  }
}
